class Mutex {
    name: string;
    locks: Promise<any>[] = [];

    constructor(name) {
        this.name = name;
    }

    addLock = () => {
        let mutexResolver;
        const mutexPromise = new Promise(resolve => {
            mutexResolver = resolve;
        });

        this.locks.push(mutexPromise);
        if (this.locks.length > 1) {
            // Mutex exist.
            return this.locks[this.locks.length - 2].then(() => mutexResolver);
        }
        return mutexResolver;
    };
}

class MutexFactory {
    mutecies = {};

    createMutex = (mutexName: string) => {
        if (typeof mutexName !== 'string') {
            return false;
        }

        const mutex = this.mutecies[mutexName] || new Mutex(mutexName);
        this.mutecies[mutexName] = mutex;
        return mutex;
    };
}

export const locks = {};
export const acquireMutex = mutex => {
    if (typeof mutex === 'string') {
        // It's a single lock.
        let mutexResolver;
        const mutexPromise = new Promise(resolve => {
            mutexResolver = resolve;
        });
        if (!locks[mutex]) {
            locks[mutex] = [];
        }
        locks[mutex].push(mutexPromise);
        if (locks[mutex].length > 1) {
            // Mutex exist.
            return locks[mutex][locks[mutex].length - 2].then(() => mutexResolver);
        }
        return mutexResolver;
    }
};
export default acquireMutex;
